import React, {useMemo, useState} from "react";
import {Trans} from '@lingui/macro';
import CustomiseColumnDrawer from "./CustomizeColumnDrawer";
import {Button, Tag} from "antd";
import {InsertRowRightOutlined} from "@ant-design/icons";
import BukkuTooltip from "../../Tooltip";
import { ColumnsHelper } from "../../Columns/ColumnsHelper";
import { useSelector } from "../../Providers/helpers/useSelector";
import { shallowEqual } from 'react-redux';
import { getMatchedFields } from "../../Editable/BatchTransaction/utilsCustomFields/getMatchedFields";
import { SubscriptionScopeKey } from '../../Access/helper/subscription/enum/SubscriptionScopeKey';
import { SubscriptionCheck } from '../../Access/helper/subscription/SubscriptionCheck';
import styled from "styled-components";
import { LockIcon } from "../../Access/common/LockIcon";

const StyledTag = styled(Tag)`
    margin-inline-end: 4px;
    font-size: 0.6rem;
    line-height: 0.8rem;
`;

const selectorFn = state => ({
    fields: state.List.fields,
    // selected: (state.LocalStorage[props.storageKey]?.columns || []).map(column => column.key),
    companyCurrencyCode: state.Auth.companyCurrencyCode,
    companyCountryCode: state.Auth.companyCountryCode,
});

/**
 * Props:
 * - storageKey: StorageKey
 * - columnProps: Object
 * @param {{
 *  type: string|null, // 'transaction' | 'contact' | 'all' | null,
 *  transactionType: string, // eg: Type.sale_invoice
 * }|null} customFieldColProps - to filter relevant custom fields for customize column
 *
 */
export default function CustomizeColumnButton(props) {
    const {
        storageKey,
        columnProps,
        customFieldColProps,
        isReport,
        filterFields,
    } = props;
    const [visible, setVisible] = useState(false);

    const { fields, companyCurrencyCode, companyCountryCode } = useSelector(
        selectorFn,
        shallowEqual,
    );

    // to support passing in filterFields function as prop for different report types with different relevant custom fields
    const filteredFields =
    typeof filterFields === "function" ? filterFields(fields) : fields;

    // to support currency codes in amount related columns (eg: Amount MYR)
    const newColumnProps = useMemo(
        () => ({ companyCurrencyCode, companyCountryCode, ...columnProps }),
        [columnProps, companyCurrencyCode, companyCountryCode],
    );

    const parsedFields = useMemo(() => {
        if (
            !customFieldColProps ||
      !(customFieldColProps.type && customFieldColProps.transactionType)
        )
            return filteredFields;
        switch (customFieldColProps.type) {
            case "transaction":
                return {
                    transaction: getMatchedFields(
                        filteredFields,
                        "transaction",
                        customFieldColProps.transactionType,
                    ),
                    contact: [],
                };
            case "contact":
                return {
                    transaction: [],
                    contact: getMatchedFields(
                        filteredFields,
                        "contact",
                        customFieldColProps.transactionType,
                    ),
                };
            case "all":
            default:
                return {
                    transaction: getMatchedFields(
                        filteredFields,
                        "transaction",
                        customFieldColProps.transactionType,
                    ),
                    contact: getMatchedFields(
                        filteredFields,
                        "contact",
                        customFieldColProps.transactionType,
                    ),
                };
        }
    }, [filteredFields, customFieldColProps]);

    const columns = ColumnsHelper.getAllColumns(
        storageKey,
        newColumnProps,
        parsedFields,
    );

    console.log("aaa columns", { columns });
    const options = [];
    columns.forEach(column => {
        let { label } = column;
        if (column.colKeyGroup === "custom_fields") {
            label = React.cloneElement(column.label, {
                children: [
                    <StyledTag color="blue">
                        <Trans>Custom</Trans>
                    </StyledTag>,
                    ...(column.label.props.children?.props.children || []),
                ],
            });
        }
        options.push({
            value: column.key,
            label,
            disabled: column.required,
        });
    });

    // const options = useMemo(
    //     () => ColumnsHelper.getAllColumns(storageKey, newColumnProps, parsedFields, true).map(column => ({
    //         value: column.key,
    //         label: column.label,
    //         disabled: column.required,
    //     })), [newColumnProps, storageKey, parsedFields]);

    const subscribedToAdvancedReportingTools = SubscriptionCheck.withKeys(
        SubscriptionScopeKey.ADVANCED_REPORTING_TOOLS,
    ).hasSubscriptionTo();

    const tooltipLabel = () => {
        if (isReport && !subscribedToAdvancedReportingTools) {
            return (
                <div>
                    <Trans>Select Columns</Trans>
                    <LockIcon />
                </div>
            );
        }

        return <Trans>Select Columns</Trans>;
    };

    return [
        <CustomiseColumnDrawer
            key="drawer"
            storageKey={storageKey}
            visible={visible}
            closeDrawer={() => setVisible(false)}
            options={options}
        />,
        <BukkuTooltip
            title={tooltipLabel()}
            key="button"
            popupContainerId="parentElement"
        >
            <Button
                shape="circle"
                icon={<InsertRowRightOutlined />}
                onClick={() => setVisible(true)}
                disabled={isReport && !subscribedToAdvancedReportingTools}
            />
        </BukkuTooltip>,
    ];
}
